<template>
  <TCalloutExclamationBlock :data-test="'TCalloutErrorGeneric-' + dataTestName">
    {{ $t('generic_error') }}
  </TCalloutExclamationBlock>
</template>

<script setup lang="ts">
defineProps({
  dataTestName: { type: String, required: false, default: '' },
});
</script>
